import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import Table from "@khan/component-table";

import NumberedPaginationButtons from "#districts-package/components/numbered-pagination-buttons.tsx";
import {getLastPageIndex} from "#districts-package/components/numbered-pagination-util.ts";

type Props = JSX.LibraryManagedAttributes<
    typeof Table,
    React.ComponentProps<typeof Table>
> & {
    isAdjustingFilters?: boolean;
    hasFixedTopRow?: boolean;
    // set this (along with pageIndex and pageSize) to enable pagination
    setPageIndex?: (pageIndex: number) => void;
};

/**
 * A wrapper component for Table, for use in district reports.
 */
class ReportTable extends React.Component<Props> {
    render(): React.ReactNode {
        const {isAdjustingFilters, setPageIndex, ...tableProps} = this.props;

        return (
            <>
                <View
                    style={[
                        styles.tableWrapper,
                        !!isAdjustingFilters && styles.adjustingFilters,
                    ]}
                >
                    <Table
                        {...tableProps}
                        tableHeadingRenderer={(tr) => (
                            <thead className={css(styles.tableHeader)}>
                                {tr}
                            </thead>
                        )}
                    />
                </View>
                {!!tableProps.pageSize && setPageIndex && (
                    <>
                        <Strut size={spacing.xxLarge_48} />
                        <NumberedPaginationButtons
                            currentPageIndex={tableProps.pageIndex || 0}
                            lastPageIndex={getLastPageIndex(
                                tableProps.data.length,
                                tableProps.pageSize,
                            )}
                            fetchPage={setPageIndex}
                        />
                    </>
                )}
            </>
        );
    }
}

const styles = StyleSheet.create({
    tableWrapper: {
        // HACK(mdr): The Table component has built-in margin, which is
        //     misaligning us with our container. That's not great! Let's
        //     just... hack it away ^_^`
        marginLeft: -12,
        marginRight: -12,
    },
    adjustingFilters: {
        cursor: "not-allowed",
        pointerEvents: "none",
        opacity: 0.2,
    },
    tableHeader: {
        backgroundColor: color.offWhite,
    },
});

export default ReportTable;
